import Chip from '@/shared/components/Chip/Chip'
import styles from './TranslationItem.module.scss'

interface TranslationItemProps {
  languageCode: string
  translationText: string
  textAlignment?: 'left' | 'right'
  fontSize?: string
  missingTranslation?: boolean
}

function TranslationItem(props: TranslationItemProps) {
  const {
    languageCode,
    translationText,
    textAlignment = 'right',
    fontSize,
    missingTranslation = false
  } = props
  return (
    <div className={styles.translationItemWrapper}>
      <div
        className={` ${
          textAlignment === 'left' ? styles.orderSecond : styles.orderFirst
        }`}
      >
        <Chip
          label={languageCode}
          color={missingTranslation ? 'secondary' : 'primary'}
          uppercase
        />
      </div>
      {translationText ? (
        <div
          className={`${fontSize || 'body-medium'} ${styles.translationText} ${
            textAlignment === 'left' ? styles.orderFirst : styles.orderSecond
          } ${missingTranslation ? styles.missingTranslationText : ''}`}
        >
          {translationText}
        </div>
      ) : null}
    </div>
  )
}

export default TranslationItem
